import React, { useState } from "react";
import { DailogBox } from "../../../components/Elements/DailogBox/DailogBox";
import { Input, InputNumber } from "antd";
import CustomButton from "../../../components/Elements/Buttons/CustomButtons";
import { API_URLS } from "../../../api/apiUrls";
import { postApi } from "../../../api/api_instance";
// import { toast } from "react-hot-toast";
import { AcceptDialog } from "../../../components/Elements/DailogBox/AcceptDialog";

const CreateProjectTypeDialog = ({
  onOpen,
  onClose,
  onSuccess,
  onSave,
  onError,
}) => {
  const [project_type, setprojectType] = useState("");
  const [description, setDescription] = useState("");
  const [service_cost, setServiceCost] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState({
    project_type: "",
    description: "",
    service_cost: "",
  });

  const handleSave = async () => {
    let isValid = true;
    const errors = { project_type: "", description: "", service_cost: "" };

    if (!project_type) {
      errors.project_type = "Project Type is required";
      isValid = false;
    }
    if (!description) {
      errors.description = "Description is required";
      isValid = false;
    }
    if (service_cost === undefined || service_cost === null || service_cost < 0) {
      errors.service_cost = "Valid service cost is required";
      isValid = false;
    }

    setErrorMessage(errors);
    if (!isValid) return;

    setLoading(true);
    try {
      const response = await postApi({
        apiUrl: API_URLS.ADD_PROJECT_TYPE,
        data: { project_type, description, service_cost },
      });

      if (response.success) {
        // toast.success("Project Type created successfully!");
        onSave();
        if (onSuccess) onSuccess();
      } else {
        if (onError)
          onError(response.message || "Failed to create Project Type");
      }
    } catch (error) {
      if (onError)
        onError(error.response?.data?.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setErrorMessage({});
    onClose();
  };
  const handleAcceptClose = () => {
    // setShowAcceptDialog(false);
    if (onSuccess) onSuccess();
  };

  return (
    <>
      <DailogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="800px">
        <div>
          <h3 className="text-xl font-bold text-[#06513D]">
            Add New Project Type
          </h3>
          {/* <div className="w-1/3 h-1 bg-gradient-to-r from-green-500 to-blue-600 mt-2"></div> */}
        </div>

        <div className="rounded-xl border mt-8 px-12">
          <div className="mt-3 mb-4">
            <hr />
          </div>

          <div className="flex flex-col gap-6">
            <div className="flex flex-col gap-2">
              <label htmlFor="project_type" className="text-sm font-medium text-gray-700 text-left">Project Type</label>
              <Input
                id="project_type"
                value={project_type}
                onChange={(e) => setprojectType(e.target.value)}
                placeholder="Project Type"
                className="h-14 rounded-lg"
              />
              {errorMessage.project_type && (
                <div className="text-red-500 text-sm text-left">
                  {errorMessage.project_type}
                </div>
              )}
            </div>

            <div className="flex flex-col gap-2">
              <label htmlFor="description" className="text-sm font-medium text-gray-700 text-left">Description</label>
              <Input
                id="description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Description"
                className="h-14 rounded-lg"
              />
              {errorMessage.description && (
                <div className="text-red-500 text-sm text-left">
                  {errorMessage.description}
                </div>
              )}
            </div>

            <div className="flex flex-col gap-2">
              <label htmlFor="service_cost" className="text-sm font-medium text-gray-700 text-left">Service Cost (₹)</label>
              <InputNumber
                id="service_cost"
                value={service_cost}
                onChange={(value) => setServiceCost(value)}
                placeholder="Service Cost"
                className="w-full h-14 rounded-lg flex items-center"
                min={0}
              />
              {errorMessage.service_cost && (
                <div className="text-red-500 text-sm text-left">
                  {errorMessage.service_cost}
                </div>
              )}
            </div>
          </div>

          <div className="flex justify-center gap-6 p-5">
            <CustomButton
              buttonType="button"
              variant="cancel"
              buttonText="Cancel"
              onClick={handleCancel}
              className="text-base font-normal h-[50px] w-[160px]"
            />

            <CustomButton
              buttonType="button"
              variant="ok"
              buttonText="Save"
              onClick={handleSave}
              className="text-base font-normal h-[50px] w-[160px]"
            />
          </div>
        </div>
      </DailogBox>

      {/* {showAcceptDialog && (
        <AcceptDialog
          open={showAcceptDialog}
          close={handleAcceptClose}
          heading="Project Type Created"
          subheading="The Project Type has been successfully created."
          success={true}
        />
      )} */}
    </>
  );
};

export default CreateProjectTypeDialog;
